var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 29 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.498 18.479c4.919 0 8.906-4.076 8.906-9.104S19.417.27 14.498.27c-4.919 0-8.906 4.076-8.906 9.104s3.987 9.104 8.906 9.104zM14.499 20.395c-3.728.005-7.303 1.52-9.94 4.215C1.924 27.305.44 30.96.438 34.77a.97.97 0 0 0 .274.678c.176.18.414.28.663.28h26.25c.249 0 .487-.1.663-.28a.97.97 0 0 0 .274-.678c-.003-3.81-1.486-7.465-4.123-10.16-2.636-2.695-6.21-4.21-9.939-4.215z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarAlt);
export default __webpack_public_path__ + "static/media/avatar-alt.e6a662c27b1a36445ce56602fd4d3834.svg";
export { ForwardRef as ReactComponent };